import * as React from "react";
import styles from "./shipping.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobeEurope } from "@fortawesome/free-solid-svg-icons";

const Shipping = () => {
  return (
    <div className={styles.shipping} id="money-back">
      <div className={styles.content}>
        <FontAwesomeIcon icon={faGlobeEurope} className={styles.image} />
        <div className={styles.text}>
          <h1>We pay shipping</h1>
          <p>
            Worldwide shipping in 6-9 days, on us. Orders dispatched the same day as ordering.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Shipping
